import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory, getLatestArticles } from '@/mocks/articles';
import type { Article } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'film-tv');
  const [displayArticles, setDisplayArticles] = useState<Article[]>([]);

  const currentCategory = categories.find((c) => c.slug === activeSlug);

  useEffect(() => {
    if (slug && slug !== activeSlug) {
      setActiveSlug(slug);
    }
  }, [slug, activeSlug]);

  useEffect(() => {
    if (activeSlug === 'all') {
      setDisplayArticles(getLatestArticles(20));
    } else {
      setDisplayArticles(getArticlesByCategory(activeSlug));
    }
    if (currentCategory) {
      document.title = `${currentCategory.name} - 17吃瓜网 | 娱乐八卦吃瓜资讯`;
    }
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && currentCategory) {
      metaDesc.setAttribute('content', `${currentCategory.description} - 17吃瓜网专注娱乐八卦资讯聚合，每日更新最新吃瓜内容。`);
    }
  }, [activeSlug, currentCategory]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-16">
        <Breadcrumb />

        <section className="py-8 md:py-10 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                {currentCategory ? currentCategory.name : '全部文章'}
              </h1>
              <p className="text-sm text-foreground-600 mt-2 leading-relaxed">
                {currentCategory ? currentCategory.description : '浏览17吃瓜网全部娱乐八卦资讯'}
              </p>
            </div>

            <div className="flex items-center gap-1.5 mb-8 overflow-x-auto pb-2 flex-wrap">
              <Link
                to="/category/all"
                onClick={() => setActiveSlug('all')}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  activeSlug === 'all'
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  onClick={() => setActiveSlug(cat.slug)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {displayArticles.length === 0 ? (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-5xl text-foreground-300"></i>
                <p className="text-foreground-500 mt-4">该分类暂无文章</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {displayArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    image={article.image}
                    categoryName={article.categoryName}
                    categorySlug={article.categorySlug}
                    publishDate={article.publishDate}
                    views={article.views}
                  />
                ))}
              </div>
            )}
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}